import { __ } from "@wordpress/i18n";
import { useOutletContext } from 'react-router-dom';
import { Row, Col, Form, OverlayTrigger, Tooltip, ToggleButton, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import SortableAccordion from '../../components/SortableAccordion/SortableAccordion';
const ContentPlacement = () => {
    const { settings, settingsDetails, settingsLoading, handleChange } = useOutletContext();

    return (
        <>
            <div className="setting-unit">
                <Row>
                    <Col lg={6}>
                        {
                            settingsLoading
                                ?
                                <>
                                    <div className="loading-skeleton h4" style={{ width: '60%' }}></div>
                                    <div className="loading-skeleton p" style={{ width: '70%' }}></div>
                                </>
                                :
                                <>
                                    {settingsDetails?.cart?.content_placement?.enabled?.title &&
                                        <h6 className="h6">
                                            {settingsDetails.cart.content_placement.enabled.title}
                                            {settingsDetails?.cart?.content_placement?.enabled?.hint &&
                                                <OverlayTrigger overlay={<Tooltip>{settingsDetails.cart.content_placement.enabled.hint}</Tooltip>}>
                                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                                </OverlayTrigger>
                                            }
                                        </h6>
                                    }
                                    {settingsDetails?.cart?.content_placement?.enabled?.intro &&
                                        <p className="mb-0" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.enabled.intro }} />
                                    }
                                </>
                        }
                    </Col>

                    <Col lg={6}>
                        {
                            !settingsLoading &&

                            <Form.Group>
                                {settingsDetails?.cart?.content_placement?.enabled?.before &&
                                    <Form.Label htmlFor="cart_content_placement_enabled" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.enabled.before }} />
                                }
                                <Form.Check
                                    id="cart_content_placement_enabled"
                                    type="switch"
                                    // label="" 
                                    onChange={(e) => handleChange('cart.content_placement.enabled', e.target.checked)}
                                    checked={settings?.cart?.content_placement?.enabled ? true : false}

                                />
                                {settingsDetails?.cart?.content_placement?.enabled?.after &&
                                    <Form.Text className="text-muted" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.enabled.after }} />
                                }
                            </Form.Group>
                        }
                    </Col>

                </Row>
            </div>
            <div className="setting-unit mt-3">
                <Row>
                    <Col lg={6}>
                        {
                            settingsLoading
                                ?
                                <>
                                    <div className="loading-skeleton h4" style={{ width: '60%' }}></div>
                                    <div className="loading-skeleton p" style={{ width: '70%' }}></div>
                                </>
                                :
                                <>
                                    {settingsDetails?.cart?.content_placement?.content?.title &&
                                        <h6 className="h6">
                                            {settingsDetails.cart.content_placement.content.title}
                                            {settingsDetails?.cart?.content_placement?.content?.hint &&
                                                <OverlayTrigger overlay={<Tooltip>{settingsDetails.cart.content_placement.content.hint}</Tooltip>}>
                                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                                </OverlayTrigger>
                                            }
                                        </h6>
                                    }
                                    {settingsDetails?.cart?.content_placement?.content?.intro &&
                                        <p className="mb-0" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.content.intro }} />
                                    }
                                </>
                        }
                    </Col>

                    <Col lg={6}>
                        {
                            !settingsLoading &&

                            <Form.Group>
                                {settingsDetails?.cart?.content_placement?.content?.before &&
                                    <Form.Label htmlFor="cart_content_placement_content" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.content.before }} />
                                }

                                <SortableAccordion
                                    name='cart_content_placement_content'
                                    options={{
                                        addButton: __("Add New Block", 'store-addons-for-woocommerce'),
                                        titlePrefix: __("Content Block", 'store-addons-for-woocommerce'),
                                    }}
                                    fields={[
                                        { type: "input", name: "title", placeholder: __("Title", 'store-addons-for-woocommerce'), className: "input-field", label: __("Title", 'store-addons-for-woocommerce') },
                                        { type: "textarea", name: "note", placeholder: __("Note", 'store-addons-for-woocommerce'), className: "textarea-field", label: __("Note", 'store-addons-for-woocommerce') },
                                        { type: "input", name: "button_text", placeholder: __("Button Text", 'store-addons-for-woocommerce'), className: "input-field", label: __("Button Text", 'store-addons-for-woocommerce') },
                                        { type: "input", name: "button_url", placeholder: __("Button URL", 'store-addons-for-woocommerce'), className: "input-field", label: __("Button URL", 'store-addons-for-woocommerce') },
                                        { type: "media-uploader", name: "icon", placeholder: __("Address 1", 'store-addons-for-woocommerce'), className: "input-field", label: __("Image", 'store-addons-for-woocommerce') },

                                    ]}
                                    defaultValues={settings?.cart?.content_placement?.content}
                                    onChange={(value) => {
                                        // console.log(value);
                                        handleChange('cart.content_placement.content', value);
                                    }}
                                />
                                {settingsDetails?.cart?.content_placement?.content?.after &&
                                    <Form.Text className="text-muted" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.content.after }} />
                                }
                            </Form.Group>
                        }
                    </Col>

                </Row>
            </div>
            <div className="setting-unit mt-3">
                <Row>
                    <Col lg={6}>
                        {
                            settingsLoading
                                ?
                                <>
                                    <div className="loading-skeleton h4" style={{ width: '60%' }}></div>
                                    <div className="loading-skeleton p" style={{ width: '70%' }}></div>
                                </>
                                :
                                <>
                                    {settingsDetails?.cart?.content_placement?.layout?.title &&
                                        <h6 className="h6">
                                            {settingsDetails.cart.content_placement.layout.title}
                                            {settingsDetails?.cart?.content_placement?.layout?.hint &&
                                                <OverlayTrigger overlay={<Tooltip>{settingsDetails.cart.content_placement.layout.hint}</Tooltip>}>
                                                    <FontAwesomeIcon icon={faQuestionCircle} />
                                                </OverlayTrigger>
                                            }
                                        </h6>
                                    }
                                    {settingsDetails?.cart?.content_placement?.layout?.intro &&
                                        <p className="mb-0" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.layout.intro }} />
                                    }
                                </>
                        }
                    </Col>

                    <Col lg={6}>
                        {
                            !settingsLoading &&

                            <Form.Group>
                                {settingsDetails?.cart?.content_placement?.layout?.before &&
                                    <Form.Label htmlFor="cart_content_placement_layout" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.layout.before }} />
                                }

                                <Row>
                                    {
                                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((layoutOption, idx) => (
                                            <Col md={4} key={idx} className="mb-4">
                                                <ToggleButton
                                                    id={`layout-${idx}`}
                                                    type="radio"
                                                    variant={settings?.cart?.content_placement?.layout == layoutOption ? 'outline-success' : 'outline-secondary'}
                                                    name='layout'
                                                    // value={image.id}
                                                    // checked={selectedValue == image.id}
                                                    // onChange={(e) => onChange(e.currentTarget.value)}
                                                    // className={`rounded-0 p-0 border-3 w-100 ${selectedValue == image.id ? 'active-image' : ''}`}
                                                    className={`rounded-0 p-0 border-3 w-100 ${settings?.cart?.content_placement?.layout == layoutOption ? 'active-image' : ''}`}
                                                    onChange={(e) => handleChange('cart.content_placement.layout', layoutOption)}
                                                >
                                                    <div className={`content-layout content-layout-${layoutOption} border rounded-2 p-2`}>
                                                        <div className="img-con">
                                                            <span></span>
                                                        </div>
                                                        <div className="text-con d-flex flex-column">
                                                            <span className="d-inline-block" style={{ width: '100%' }}></span>
                                                            <span className="d-inline-block" style={{ width: '80%' }}></span>
                                                            <span className="d-inline-block" style={{ width: '60%' }}></span>
                                                            { layoutOption > 6 &&
                                                                <>
                                                                    <span className="d-inline-block" style={{ width: '100%' }}></span>
                                                                    <span className="d-inline-block" style={{ width: '80%' }}></span>
                                                                    <span className="d-inline-block" style={{ width: '60%' }}></span>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>

                                                </ToggleButton>

                                            </Col>
                                        ))
                                    }
                                </Row>
                                {settingsDetails?.cart?.content_placement?.content?.after &&
                                    <Form.Text className="text-muted" dangerouslySetInnerHTML={{ __html: settingsDetails.cart.content_placement.content.after }} />
                                }
                            </Form.Group>
                        }
                    </Col>

                </Row>
            </div>
        </>
    );
};

export default ContentPlacement;